
export interface IGift {
    gift_id: string,
    tags: string[],
    name: string,
    thumb_url: string,
    image_url: string,
    front_value: number,
    cost_price_range: number[],
    taobao_keyword: string,
    pdd_keyword: string,
}

export class Gifts {
    constructor(public readonly data: { [key: string]: IGift }) {
        //
    }

}
